import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import TextField from "@/components/TextField";

import Popin from "@/components/Popin";

import { useStyles } from "../style";
import { formatNumTel, validerFormatNumTel } from "@/utils/phone";
import { useEffect, useState } from "react";

interface PopinNumTelProps {
  onClosePopin: () => void;
}

export const PopinNumTel = ({ onClosePopin }: PopinNumTelProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [formattedValue, setFormattedValue] = useState("");
  const [numeroTel, setNumeroTel] = useState<string>("");

  const validerNumTelGest = (): void => {
    if (validerFormatNumTel(numeroTel)) {
      localStorage.setItem("NUM_TEL_GEST", formatNumTel(numeroTel));
      onClosePopin();
      setFormattedValue("");
      setNumeroTel("");
    } else {
      setFormattedValue(t("pno.erreurFormatNumGestionnaire"));
    }
  };
  const closePopup = (): void => {
    onClosePopin();
    setNumeroTel("");
  };
  useEffect(() => {
    setFormattedValue("");
  }, [numeroTel]);

  return (
    <Popin
      title={"Renseigner votre numéro de téléphone"}
      content={
        <Box className={classes.popinLayout}>
          <Typography variant="h6">Entrer votre numéro de téléphone</Typography>
          <TextField
            label={t("pno.recapitulatif.numTelephoneProprietaire")}
            value={numeroTel}
            type="number"
            variant="outlined"
            onChange={(e) => setNumeroTel(e.target.value)}
            required
          />
          <>
            <Typography>{formattedValue}</Typography>
          </>
        </Box>
      }
      open={true}
      onClose={closePopup}
      onValidate={validerNumTelGest}
      cancelButtonLabel={t("pno.recapitulatif.annuler")}
      validateButtonLabel={t("pno.recapitulatif.valider")}
    />
  );
};
